import React from "react";

import { Box, Grid, Table, TableBody, TableRow, useTheme } from "@mui/material";
import mainStyles from "styles";

import DisplayHeading from "../../shared/display-heading";
import { TrainingDataMigrationWrapper } from "./training-data-migration/training-data-migration-wrapper";

const TrainingDataGovernanceTab = () => {
  const classes = mainStyles();
  const theme = useTheme();

  return (
    <Grid container>
      <Grid item xs={12} sx={classes.paddingTopSmall}>
        <DisplayHeading>Training Data Governance</DisplayHeading>
      </Grid>
      <Grid item xs={12}>
        <Box
          style={{
            borderColor: theme.palette.divider,
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "5px",
            margin: "20px",
          }}
        >
          <Table size="medium">
            <TableBody>
              <TableRow>
                <TrainingDataMigrationWrapper />
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Grid>
    </Grid>
  );
};

export default TrainingDataGovernanceTab;
